import { requestShopBalance } from 'helpers/web_to_client'

export const BALANCE_REQUEST_START = 'balance/REQUEST_START'
export const BALANCE_REQUEST_SUCCESS = 'balance/REQUEST_SUCCESS'
export const BALANCE_REQUEST_ERROR = 'balance/REQUEST_ERROR'

export function requestStart() {
    return {
        type: BALANCE_REQUEST_START,
    }
}

export function requestError(errorData) {
    return {
        type: BALANCE_REQUEST_ERROR,
        payload: errorData,
    }
}

export function requestSuccess(data) {
    return {
        type: BALANCE_REQUEST_SUCCESS,
        payload: data,
    }
}

export function requestBalance() {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.balance.isLoading) {
            return
        }

        dispatch(requestStart())
        try {
            const balance = await requestShopBalance()
            dispatch(requestSuccess(balance))
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request balance', e)
            dispatch(requestError(e.message))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/balance.js